import { Col, Container, Form, Row, Spinner } from 'react-bootstrap'

import React, { useEffect, useState } from 'react'

import { Dashboard, useGetBiDashboardsQuery } from '../../shared/insights/store/insights'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import DashboardView from '../Analytics/DashboardView'
import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { NoQuotaModalBody, NoQuotaModalFooter, NoQuotaModalHeader } from '../Analytics/NoQuotaModal'
import './ContactAnalytics.scss'

export type ContactAnalyticsParams = {
  userId: string
}

export const ContactAnalytics: React.FC<ContactAnalyticsParams> = ({ userId }) => {
  const { hasQuota, isFetching: quotasIsFetching } = useZocksQuota()
  const dashboardAvailable = hasQuota('insights.enabled.value')
  const accountId = useAppSelector(selectAccountId)
  const { data: dashboards, isLoading } = useGetBiDashboardsQuery({
    accountId,
    filters: [{ filterKey: 'userId', filterValue: userId, filterOperator: 'equals' }],
    dashboardIds: ['contact_analytics'],
  })

  const [activeDashboard, setActiveDashboard] = useState<Dashboard | undefined>()

  useEffect(() => {
    if (dashboards && dashboards.length > 0) {
      setActiveDashboard(dashboards[0])
    }
  }, [dashboards])

  const changeDashboard = (key: string | null) => {
    if (key) {
      const dashboard = dashboards?.find((dashboard) => dashboard.id === key)
      if (dashboard) {
        setActiveDashboard(dashboard)
      }
    }
  }
  return (
    <Container className='d-flex flex-column zocks-gap-1.25 p-0' fluid>
      {dashboardAvailable && !quotasIsFetching && (
        <>
          {isLoading && (
            <div className='d-flex align-items-center justify-content-center mt-4'>
              <Spinner />
            </div>
          )}
          {dashboards && dashboards.length > 1 && (
            <Row className='mt-4'>
              <Col>
                <Form.Select onChange={(e) => changeDashboard(e.target.value)}>
                  {dashboards.map((dashboard) => {
                    return (
                      <option key={dashboard.id} value={dashboard.id}>
                        {dashboard.name}
                      </option>
                    )
                  })}
                </Form.Select>
              </Col>
            </Row>
          )}
          <Row className='mt-4'>
            <Col>{activeDashboard && <DashboardView dashboard={activeDashboard} initialHeight={1300} urlParams={{ accountId, userId }}></DashboardView>}</Col>
          </Row>
        </>
      )}
      {!dashboardAvailable && (
        <Row>
          <Col>
            <div className='position-relative'>
              <div className='position-absolute top-0 w-100 pt-5 z-1'>
                <Container>
                  <Row>
                    <Col xs={12} md={6} className='mx-auto'>
                      <div className='d-flex flex-column gap-4 align-items-center'>
                        {NoQuotaModalHeader}
                        {NoQuotaModalBody}
                        <div className='mt-4'>{NoQuotaModalFooter}</div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className='position-absolute top-0 w-100 h-100  upgrade-info-container bg-white d-flex flex-column justify-content-start align-items-center'></div>
              <img alt='' src='https://static.zocks.io/assets/images/analytics hub_bg_2540_1429.png' className='w-100' />
            </div>
          </Col>
        </Row>
      )}
    </Container>
  )
}
